import * as React from "react";
import { IInsuranceDetails } from "@nkr/models/insurance-details";
import { Modal, Button } from "react-bootstrap";
import { NonGlobalInsuranceRow } from "./styles";

interface IProps {
    show: boolean,
    recipientCenter: string,
    recipientAlias: string,
    data: IInsuranceDetails,
    onClose: () => void
}

class NonGlobalInsurance extends React.Component<IProps, {}> {
    handleClose = () => {
        this.props.onClose();
    }

    render = () => {
        if (this.props.data == null)
            return null;

        const {
            primaryGroupName, patientName, policyIdNumber, groupNumber, healthPlanName,
            subscriberName, caseManagerName, caseManagerPhone, claimsMailingAddress } = this.props.data;

        const mailingAddress = claimsMailingAddress.length > 0 ? claimsMailingAddress.split('\r\n') : [];

        return (
            <>
                <Modal show={this.props.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <h4 className="modal-title">Insurance information for {this.props.recipientCenter} patient {this.props.recipientAlias}</h4>
                    </Modal.Header>

                    <Modal.Body style={{ fontSize: 12 }}>
                        <div className="row">
                            <div className="col-xs-12 col-lg-5">
                                <table className="table table-bordered table-condensed" style={{ marginBottom: 0 }}>
                                    <tbody>
                                        <NonGlobalInsuranceRow>
                                            <td>Primary Insurance:</td>
                                            <td>{primaryGroupName}</td>
                                        </NonGlobalInsuranceRow>
                                        <NonGlobalInsuranceRow>
                                            <td>Patient Name:</td>
                                            <td>{patientName}</td>
                                        </NonGlobalInsuranceRow>
                                        <NonGlobalInsuranceRow>
                                            <td>Policy ID #:</td>
                                            <td>{policyIdNumber}</td>
                                        </NonGlobalInsuranceRow>
                                        <NonGlobalInsuranceRow>
                                            <td>Group ID #:</td>
                                            <td>{groupNumber}</td>
                                        </NonGlobalInsuranceRow>
                                    </tbody>
                                </table>
                            </div>

                            <div className="col-xs-12 col-lg-7">
                                <table className="table table-bordered table-condensed" style={{ border: "0 none" }}>
                                    <tbody>
                                        <NonGlobalInsuranceRow>
                                            <td>Health Plan Name:</td>
                                            <td>{healthPlanName}</td>
                                        </NonGlobalInsuranceRow>

                                        <NonGlobalInsuranceRow>
                                            <td colSpan={2} style={{ borderLeft: "0 none", borderRight: "0 none" }}></td>
                                        </NonGlobalInsuranceRow>

                                        <NonGlobalInsuranceRow>
                                            <td>Claims Mailing Address:</td>
                                            <td>
                                                {mailingAddress.map((line, index) =>
                                                    <div key={index}>{line}</div>
                                                )}
                                            </td>
                                        </NonGlobalInsuranceRow>

                                        <NonGlobalInsuranceRow>
                                            <td colSpan={2} style={{ borderLeft: "0 none", borderRight: "0 none" }}></td>
                                        </NonGlobalInsuranceRow>

                                        <NonGlobalInsuranceRow>
                                            <td>Subscriber Name:</td>
                                            <td>{subscriberName}</td>
                                        </NonGlobalInsuranceRow>
                                        <NonGlobalInsuranceRow>
                                            <td>Case Manager Name:</td>
                                            <td>{caseManagerName}</td>
                                        </NonGlobalInsuranceRow>
                                        <NonGlobalInsuranceRow>
                                            <td>Case Manager Phone:</td>
                                            <td>{caseManagerPhone}</td>
                                        </NonGlobalInsuranceRow>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {/* </div> */}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button bsStyle="primary" onClick={this.handleClose}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default NonGlobalInsurance;